import { createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { id: "detail-rute" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createVNode("h6", { class: "mr-3 font-normal" }, "Detail Rute")
], -1)
const _hoisted_4 = { class: "flex items-center justify-between" }
const _hoisted_5 = { class: "mr-3 font-normal" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-refresh color-primary" }, null, -1)
const _hoisted_7 = { class: "text-primary" }
const _hoisted_8 = { class: "text-primary" }
const _hoisted_9 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIconRightGrey = _resolveComponent("InputIconRightGrey")
  const _component_Button = _resolveComponent("Button")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")
  const _component_ListCopyEditDel = _resolveComponent("ListCopyEditDel")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_DetailScheduleForm = _resolveComponent("DetailScheduleForm")
  const _component_Sidebar = _resolveComponent("Sidebar")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode("p", _hoisted_5, [
              _createVNode(_component_InputIconRightGrey, {
                modelValue: _ctx.inputSearch,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputSearch = $event)),
                placeholder: "Cari Disini ...",
                onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.searchData(_ctx.inputSearch)), ["enter"])),
                icon: _ctx.$icon.svg.searchEva,
                type: _ctx.$enumBase.input.text
              }, null, 8, ["modelValue", "icon", "type"])
            ]),
            _createVNode(_component_Button, {
              class: "btn-eee px-2 mr-3",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetFilter()))
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            (_ctx.route.meta.permission.write)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  label: "Tambah Rute",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.redirectAdd())),
                  icon: "pi pi-plus",
                  class: "font-semibold p-button-sm btn-primary"
                }))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          value: _ctx.data,
          paginator: true,
          rows: _ctx.filter.top,
          class: "table-og",
          responsiveLayout: "scroll"
        }, {
          footer: _withCtx(() => []),
          default: _withCtx(() => [
            _createVNode(_component_Column, { header: "No" }, {
              body: _withCtx((slotProps) => [
                _createVNode("pre", _hoisted_7, _toDisplayString(slotProps.index + 1), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Agen",
              field: "AgenString",
              sortable: true
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", _hoisted_8, _toDisplayString(`${slotProps.data.AgenString}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Kedatangan" }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", null, _toDisplayString(slotProps.data.WaktuKedatanganString == "x"
                    ? `-`
                    : `${_ctx.moment(slotProps.data.WaktuKedatangan).format("HH:mm")} WIB`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              header: "Keberangkatan",
              field: "WaktuKeberangkatanString",
              sortable: true
            }, {
              body: _withCtx((slotProps) => [
                _createVNode("p", null, _toDisplayString(slotProps.data.WaktuKeberangkatanString == "x"
                    ? `-`
                    : `${_ctx.moment(slotProps.data.WaktuKeberangkatan).format("HH:mm")} WIB`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, { header: "Jenis Tanggal Penerimaan" }, {
              body: _withCtx((slotProps) => [
                (slotProps.data.TanggalPenerimaan)
                  ? (_openBlock(), _createBlock("p", _hoisted_9, _toDisplayString(slotProps.data.TanggalPenerimaan.Nama), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, null, {
              body: _withCtx((slotProps) => [
                (_ctx.route.meta.permission.update || _ctx.route.meta.permission.delete)
                  ? (_openBlock(), _createBlock("i", {
                      key: 0,
                      class: "pi pi-ellipsis-h text-base cursor-pointer text-black",
                      "aria:haspopup": "true",
                      onClick: ($event: any) => (_ctx.showDropDown($event, slotProps.data))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "rows"])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, { ref: "op" }, {
      default: _withCtx(() => [
        _createVNode(_component_ListCopyEditDel, {
          del: _ctx.route.meta.permission.delete,
          edit: _ctx.route.meta.permission.update,
          onDel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteData(_ctx.dataForm.Id))),
          onEdit: _cache[6] || (_cache[6] = ($event: any) => (_ctx.editData(_ctx.dataForm)))
        }, null, 8, ["del", "edit"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_Sidebar, {
      class: "type-bus-sidebar",
      visible: _ctx.sliderActive,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.sliderActive = $event)),
      showCloseIcon: false,
      position: "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DetailScheduleForm, {
          idJadwal: _ctx.idJadwal,
          data: _ctx.dataForm,
          onCloseSidebar: _cache[7] || (_cache[7] = ($event: any) => (_ctx.closeSidebar())),
          onReloadData: _cache[8] || (_cache[8] = ($event: any) => (_ctx.getDataDetailSchedule()))
        }, null, 8, ["idJadwal", "data"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}